export default __webpack_public_path__ + "static/color-roles-light-b53c12ad6ea6f261fc1edb3492ab2a9c.png";